/**
 * Users can select a way to name their series.
 */
export enum SeriesNameType {
  /**
   * Users can select label values to include in the series name.
   */
  Labels = 'Labels',
  /**
   * Users can define a regex, and select capture groups to include in the series name.
   */
  Regex = 'Regex',
}

export const SERIES_NAME_TYPE_DEFAULT = SeriesNameType.Labels;
export const SERIES_NAME_TYPE_OPTIONS = [
  {
    key: SeriesNameType.Labels,
    label: 'Labels',
    description: 'Name series by using the syntax: {{ label_name }}',
  },
  {
    key: SeriesNameType.Regex,
    label: 'Regex',
    description: 'Name series by defining a regex and using $1, $2, etc. to include capture groups',
  },
];
